import React, {Component} from "react";
import BackButton from "../BackButton";
import FormControl from "../FormControl";
import Form from "../Form";

class SedimentoPlayaForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: {},
            zona: [
                "Zona Humeda",
                "Zona Seca",
                "Zona Sumergida"
            ],
            sedimento: [
                "Arenas Finas",
                "Arenas Gruesas",
                "Arenas Medianas",
                "Gravas"
            ]
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillReceiveProps(props) {
        this.setState({
            record: props.record
        });
    }

    handleInputChange(event) {
        this.props.handleInputChange(event);
    }

    handleSubmit(event) {
        this.props.handleSubmit(event);
    }

    render() {
        return (
            <div className="container">
                <Form submit={this.handleSubmit}>
                    <div className="row">
                        <div className="col">
                            <h4>Composición del sedimento</h4>
                        </div>
                    </div>
                    <div className="row">
                        <FormControl
                            label="Número de transecto playa"
                            type="number"
                            name="transecto"
                            autoFocus={true}
                            col={6}
                            value={this.state.record.transecto}
                            onChange={this.handleInputChange}
                            className="form-control"/>

                        <div className="col-6 form-group">
                            <label>Zona</label>
                            <select className="form-select form-control"
                                    name="zona"
                                    value={this.state.record.zona}
                                    onChange={this.handleInputChange}>
                                {this.state.zona.map(zona => (
                                    <option>{zona}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6 form-group">
                            <label>Sedimento</label>
                            <select className="form-select form-control"
                                    name="sedimento"
                                    value={this.state.record.sedimento}
                                    onChange={this.handleInputChange}>
                                {this.state.sedimento.map(sedimento => (
                                    <option>{sedimento}</option>
                                ))}
                            </select>
                        </div>
                        <FormControl
                            label="Masa (g)"
                            type="number"
                            step="any"
                            name="masa"
                            col={6}
                            value={this.state.record.masa}
                            onChange={this.handleInputChange}/>
                    </div>
                    <div className="row">
                        <FormControl
                            label="Concentración (%)"
                            type="number"
                            step="any"
                            name="concentracion"
                            col={6}
                            value={this.state.record.concentracion}
                            onChange={this.handleInputChange}
                            className="form-control"/>
                    </div>

                    <div className="row justify-content-end">
                        <div className="col-4 text-right">
                            <input type="submit"
                                   value="Guardar"
                                   className="btn btn-primary form-submit"/>
                            &nbsp;<BackButton/>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
}

export default SedimentoPlayaForm;